import React from "react";
import "./ProgressBar.css";

function ProgressBar({ percent, title }) {
	return (
		<div className="card">
			<div className="box">
				<div className="percent">
					<svg>
						<circle cx="70" cy="70" r="70"></circle>
						<circle cx="70" cy="70" r="70"></circle>
					</svg>
					<div className="number">
						<h2>
							{percent}
							<span>%</span>
						</h2>
					</div>
				</div>
				<h2 className="text">{title}</h2>
			</div>
		</div>
	);
}

export default ProgressBar;
